import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3be99e90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-box" }
const _hoisted_2 = { class: "flex between header" }
const _hoisted_3 = { class: "left-search" }
const _hoisted_4 = { class: "upd-box" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "上传列表：", -1))
const _hoisted_6 = { class: "flex wrap upd-item-box" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "progress" }
const _hoisted_11 = { style: {"text-align":"left"} }
const _hoisted_12 = {
  key: 2,
  class: "icon-box flex wrap"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "item-box" }
const _hoisted_17 = { class: "icon-choice-true" }

import { getToken } from '@/plugins/cookie';
import { CheckOutlined, SearchOutlined } from '@ant-design/icons-vue';
import { Input, message, Progress, Pagination } from 'ant-design-vue';
import { ref, watch, reactive } from 'vue';
import { useUpload } from '../../articalCategory/multipleUpload';
import http from '@/api/conentCenter/portalDecoration';
import router from '@/router';
import CDelModal from '@/components/CDelModal.vue';
import { emptyDataSec } from '@/assets';
import CLoading from '@/components/CLoading.vue';
import emitter from '@/utils/mitt';
import { ElUpload } from 'element-plus';
interface Item {
  choice: boolean;
  image: string;
  name: string;
  id: number;
}
// 分页

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    dataSource: null
  },
  setup(__props: any) {

const props = __props as { dataSource: any };

const aInputSearch = Input.Search;
const aProgress = Progress;
const aPagination = Pagination;
const search = ref('');
const choice = ref<boolean>(false);
const choice_all = ref<boolean>(false);
const delVisible = ref<boolean>(false);
const showLoading = ref<boolean>(false);

const menuKey: any = ref(props.dataSource.menuKey);
const gatewayId = router.currentRoute.value.params.gatewayId;
const { fileList, viewFileList, beforeUpload, handleChange } = useUpload({ type: 1 });
watch(
  () => props.dataSource.menuKey,
  (nv) => {
    menuKey.value = nv;
    getList();
  }
);
watch(
  () => props.dataSource.visible,
  () => {
    !props.dataSource.visible ? (viewFileList.value = []) : '';
  }
);
// type 0 图片 1 背景
const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 24, // 每页条数
  totalSize: 1, // 总数
  options: ['24', '36', '48', '60'], // 选项
});
const imgList = ref<Item[]>([]);
const getList = () => {
  let params = {
    portal_id: gatewayId,
    type: menuKey.value == 1 ? 0 : 1,
    page: pageConfig.current,
    page_num: menuKey.value == 1 ? 24 : 15,
    keywords: search.value,
  };
  showLoading.value = true;
  http
    .list_material({ params })
    .then((res) => {
      imgList.value = res.data.data.data;
      pageConfig.totalSize = res.data.data.total;
      pageConfig.current = res.data.data.current_page;
      imgList.value.forEach((item) => (item['choice'] = false));
      choice_all.value = false;
      showLoading.value = false;
    })
    .catch(() => {
      showLoading.value = false;
    });
};
getList();
// 删除
const deleteMaterial = () => {
  let arr: any = [];
  imgList.value.filter((e) => e.choice == true).forEach((i) => arr.push(i.id));
  let params = {
    portal_id: gatewayId,
    id: arr.join(','),
  };
  http
    .delete_material(params)
    .then((res) => {
      message.success(res.data.message);
      delVisible.value = false;
      getList();
    })
    .catch((res) => {
      message.error(res.data.error);
    });
};
const closeVisible = () => {
  delVisible.value = false;
};
// 全选
const cheakAll = () => {
  imgList.value.map((res: any) => {
    res.choice = choice_all.value;
  });
  emitCheck();
};

const delUpdItem = (index: number) => {
  viewFileList.value.splice(index, 1);
};

const saveAddFile = () => {
  viewFileList.value.forEach(async (item) => {
    await create_material(item);
  });
  setTimeout(() => {
    pageConfig.current = 1;
    getList();
  }, 500);
};

// 添加素材
const create_material = (file: any) => {
  const params: any = {
    type: menuKey.value == 1 ? 0 : 1,
    image: file.url,
    portal_id: gatewayId,
    name: file.name,
  };
  http.create_material(params).then(() => {
    viewFileList.value = [];
  });
};

const emitCheck = () => {
  let arr: any = [];
  imgList.value.filter((e) => e.choice == true).forEach((i) => arr.push(i.image));
  emitter.emit('selectIconOrBg', arr);
};

const itemCheck = (item: any) => {
  choice.value ? (item.choice = !item.choice) : (item.choice = false);
  emitCheck();
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_empty = _resolveComponent("a-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(aInputSearch), {
          class: "mod_range_picker_search",
          value: search.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
          placeholder: "搜索文件名称",
          onSearch: getList
        }, {
          enterButton: _withCtx(() => [
            _createVNode(_unref(SearchOutlined))
          ]),
          _: 1
        }, 8, ["value"]),
        _createVNode(_unref(ElUpload), {
          name: "images",
          headers: { token: _unref(getToken)() },
          accept: ".svg,.png,.jpg,.jpeg,.gif",
          action: "/api/v1/common/upload_images",
          multiple: "",
          "show-file-list": false,
          "file-list": _unref(fileList),
          "before-upload": _unref(beforeUpload),
          "http-request": _unref(handleChange)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              class: "upd-btn",
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("上传")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["headers", "file-list", "before-upload", "http-request"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_a_checkbox, {
          class: "select",
          checked: choice.value,
          "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((choice).value = $event))
        }, {
          default: _withCtx(() => [
            _createTextVNode("选择")
          ]),
          _: 1
        }, 8, ["checked"]),
        _createVNode(_component_a_checkbox, {
          class: "select",
          checked: choice_all.value,
          "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((choice_all).value = $event)),
          onChange: _cache[3] || (_cache[3] = ($event: any) => (cheakAll()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("全选")
          ]),
          _: 1
        }, 8, ["checked"]),
        _createVNode(_component_a_button, {
          type: "link",
          danger: "",
          disabled: imgList.value.filter((e) => e.choice == true).length == 0 ? true : false,
          onClick: _cache[4] || (_cache[4] = ($event: any) => (delVisible.value = true))
        }, {
          icon: _withCtx(() => [
            _createVNode(_component_svg_icon, {
              class: "mod_btn_icon",
              "icon-class": "del"
            })
          ]),
          default: _withCtx(() => [
            _createTextVNode(" 删除 ")
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(viewFileList), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "upd-item",
            key: index
          }, [
            (item.url)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: item.url,
                  alt: ""
                }, null, 8, _hoisted_7))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, "上传中")),
            _createElementVNode("div", {
              class: "del-icon",
              onClick: ($event: any) => (delUpdItem(index))
            }, [
              _createVNode(_component_svg_icon, { "icon-class": "del" })
            ], 8, _hoisted_9),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_unref(aProgress), {
                percent: item.percentage
              }, null, 8, ["percent"])
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("p", _hoisted_11, [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: saveAddFile
        }, {
          default: _withCtx(() => [
            _createTextVNode("确认添加")
          ]),
          _: 1
        })
      ])
    ], 512), [
      [_vShow, _unref(viewFileList).length != 0]
    ]),
    (showLoading.value)
      ? (_openBlock(), _createBlock(CLoading, {
          key: 0,
          style: {"height":"200px","padding-top":"120px"}
        }))
      : (imgList.value.length == 0)
        ? (_openBlock(), _createBlock(_component_a_empty, {
            key: 1,
            class: "empty_wrap",
            image: _unref(emptyDataSec),
            description: "页面暂无数据信息~"
          }, null, 8, ["image"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imgList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["icon-item", [
            choice.value || choice_all.value ? 'icon-choice' : '',
            (choice.value || choice_all.value) && item.choice ? 'icon-choices' : '',
            menuKey.value == 3 ? 'img_item' : '',
          ]]),
                  onClick: ($event: any) => (itemCheck(item))
                }, [
                  (item.image.includes('<svg'))
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        innerHTML: item.image
                      }, null, 8, _hoisted_14))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: item.image,
                        alt: ""
                      }, null, 8, _hoisted_15)),
                  _createElementVNode("div", _hoisted_16, [
                    _withDirectives(_createElementVNode("div", _hoisted_17, [
                      _createVNode(_unref(CheckOutlined), { class: "icon" })
                    ], 512), [
                      [_vShow, choice.value || choice_all.value]
                    ])
                  ])
                ], 10, _hoisted_13),
                _createElementVNode("p", {
                  class: "img_title",
                  style: _normalizeStyle({ width: menuKey.value == 1 ? '80px' : '126px' })
                }, _toDisplayString(item.name), 5)
              ]))
            }), 128))
          ])),
    _createVNode(_unref(aPagination), {
      "show-quick-jumper": "",
      total: pageConfig.totalSize,
      current: pageConfig.current,
      "onUpdate:current": _cache[5] || (_cache[5] = ($event: any) => ((pageConfig.current) = $event)),
      "page-size": pageConfig.pageSize,
      "onUpdate:pageSize": _cache[6] || (_cache[6] = ($event: any) => ((pageConfig.pageSize) = $event)),
      "show-less-items": "",
      onChange: _cache[7] || (_cache[7] = ($event: any) => (getList()))
    }, null, 8, ["total", "current", "page-size"]),
    _createVNode(CDelModal, {
      visible: delVisible.value,
      centered: "",
      close: closeVisible,
      ok: deleteMaterial
    }, null, 8, ["visible"])
  ]))
}
}

})